import Container from "@/components/ui/Container";
import SectionLabel from "@/components/ui/SectionLabel";
import GradientHeading from "@/components/ui/GradientHeading";

const doItems = [
  "Подключаем агентов к 2–5 сервисам",
  "Собираем данные о реальном выполнении кода под рабочей нагрузкой",
  "Показываем, как приоритизировать достижимые уязвимости",
  "Демонстрируем блокировку тестовой атаки (JNDI-инъекции)",
  "Формируем отчёт: что исправлять, в каком порядке и почему",
];

const needItems = [
  "Доступ к параметрам запуска JVM/CLR целевых сервисов",
  "Установленный агент мониторинга или возможность его добавить",
  "Сетевой доступ агента к системе мониторинга",
  "~2–4 часа инженера на настройку",
  "Перезапуск сервисов — но полная остановка не нужна",
];

function PillColumn({ title, items, tone, className = "" }) {
  const pill = tone === "dark" ? "bg-navy text-white" : "bg-surface text-navy";

  return (
    <div className={className}>
      <h3 className="text-[21px] font-bold leading-none tracking-[-0.21px] text-coral">
        {title}
      </h3>

      <div className="mt-[35px] flex flex-col gap-2.5">
        {items.map((text) => (
          <div
            key={text}
            className={`flex min-h-[66px] items-center rounded-[26px] px-[26px] py-3 text-[16px] font-bold leading-[1.3] ${pill}`}
          >
            {text}
          </div>
        ))}
      </div>
    </div>
  );
}

export default function RolloutSection() {
  return (
    <section>
      <Container>
        <div className="xl:grid xl:grid-cols-4 xl:gap-5">
          <SectionLabel>2–4 недели на живом контуре</SectionLabel>
          <div className="mt-3 xl:col-span-3 xl:mt-0">
            <GradientHeading className="xl:tracking-[-1.2px]">
              Процесс внедрения модуля
            </GradientHeading>
          </div>
        </div>

        <div className="mt-[60px] xl:mt-[90px] xl:grid xl:grid-cols-2 xl:gap-5">
          <PillColumn title="Что делаем" items={doItems} tone="light" />
          <PillColumn
            title="Что нужно от вас"
            items={needItems}
            tone="dark"
            className="mt-[60px] xl:mt-0"
          />
        </div>
      </Container>
    </section>
  );
}
